(function(){
  'use strict';
  var d=document, w=window;
  function runIdle(fn, timeout){
    if('requestIdleCallback' in w){ requestIdleCallback(fn,{timeout:timeout||2500}); }
    else { setTimeout(fn, timeout||1200); }
  }


  function a11yHardening(){
    // Image alt fallbacks: decorative if no meaningful context exists.
    d.querySelectorAll('img:not([alt])').forEach(function(img){
      var closestLabel = img.closest('[aria-label]');
      var label = img.getAttribute('aria-label') || img.getAttribute('title') || (closestLabel ? closestLabel.getAttribute('aria-label') : '') || '';
      img.setAttribute('alt', label);
    });

    // Name icon-only buttons/links so Lighthouse and assistive tech have stable labels.
    d.querySelectorAll('button').forEach(function(btn){
      var named = btn.getAttribute('aria-label') || btn.getAttribute('aria-labelledby') || btn.textContent.trim();
      if(!named){
        var cls = btn.className ? String(btn.className) : '';
        var label = /close/i.test(cls) ? 'Close' : /prev|previous/i.test(cls) ? 'Previous' : /next/i.test(cls) ? 'Next' : /play/i.test(cls) ? 'Play media' : /sound|volume|mute/i.test(cls) ? 'Toggle sound' : /scroll-to-top/i.test(cls) ? 'Scroll to top' : 'Button';
        btn.setAttribute('aria-label', label);
      }
      btn.querySelectorAll('svg').forEach(function(svg){ if(!svg.getAttribute('role')) svg.setAttribute('aria-hidden','true'); svg.setAttribute('focusable','false'); });
    });
    d.querySelectorAll('a').forEach(function(a){
      var named = a.getAttribute('aria-label') || a.getAttribute('aria-labelledby') || a.textContent.trim() || (a.querySelector('img[alt]')||{}).alt;
      if(!named){
        var href = a.getAttribute('href') || '';
        a.setAttribute('aria-label', href.indexOf('/cart')>-1 ? 'Cart' : href.indexOf('/search')>-1 ? 'Search' : href ? 'Open link' : 'Link');
      }
    });

    // Repair orphan list items from rich text/custom-liquid blocks.
    var orphans = Array.from(d.querySelectorAll('li')).filter(function(li){ return !li.parentElement || !/^(UL|OL|MENU)$/i.test(li.parentElement.tagName); });
    orphans.forEach(function(li){
      var ul = d.createElement('ul');
      ul.className = 'a11y-normalized-list';
      li.parentNode.insertBefore(ul, li);
      ul.appendChild(li);
    });

    // Remove common invalid ARIA states from elements where they cause Lighthouse prohibited-ARIA failures.
    d.querySelectorAll('[aria-selected]').forEach(function(el){ if(!/^(tab|option|gridcell|row)$/i.test(el.getAttribute('role')||'')) el.removeAttribute('aria-selected'); });
    d.querySelectorAll('[aria-checked]').forEach(function(el){ if(!/^(checkbox|menuitemcheckbox|menuitemradio|option|radio|switch)$/i.test(el.getAttribute('role')||'')) el.removeAttribute('aria-checked'); });

    // Add a captions track to theme videos that do not provide one. Empty file is used only when no captions exist.
    if(w.__ihwgBlankCaptions){
      d.querySelectorAll('video:not([data-ihwg-captions])').forEach(function(v){
        try{
          if(v.querySelector('track[kind="captions"]')) return;
          var tr=d.createElement('track');
          tr.kind='captions'; tr.srclang='en'; tr.label='English'; tr.src=w.__ihwgBlankCaptions;
          v.appendChild(tr); v.setAttribute('data-ihwg-captions','true');
        }catch(e){}
      });
    }
  }

  function loadHeatmap(){ if(typeof w.__ihwgLoadHeatmap==='function') w.__ihwgLoadHeatmap(); }
  var interactionEvents=['pointerdown','touchstart','keydown','scroll'];
  interactionEvents.forEach(function(evt){
    w.addEventListener(evt,function(){ runIdle(loadHeatmap, 1500); },{once:true,passive:true});
  });
  w.addEventListener('load',function(){ setTimeout(function(){ runIdle(loadHeatmap, 3000); }, 3500); });

  // Conversion-safe media optimizations only. Do not delay icon/CSS/section JS.
  function optimizeMedia(){
    d.querySelectorAll('iframe:not([loading])').forEach(function(el){
      el.setAttribute('loading','lazy');
      el.setAttribute('fetchpriority','low');
      if(!el.getAttribute('title')) el.setAttribute('title','Embedded media');
    });
    d.querySelectorAll('img:not([decoding])').forEach(function(img){ img.decoding='async'; });
    d.querySelectorAll('video').forEach(function(v){
      if(!v.closest('.product__media, .product-media-container, .media-gallery, [data-lcp-media]')){
        v.preload = v.autoplay ? 'metadata' : 'none';
      }
      v.setAttribute('playsinline','');
    });
    // Any image already below the first viewport but missing lazy gets it.
    d.querySelectorAll('main img:not([loading])').forEach(function(img, i){
      if(i > 3 && !img.closest('.product__media, .product-media-container, .hero, .banner, .yas-hero, [data-lcp-media]')){
        img.loading='lazy'; img.decoding='async';
      }
    });
    // First meaningful image gets priority if the Liquid did not set it.
    var lcpImg=d.querySelector('main img:not([loading="lazy"])');
    if(lcpImg && !lcpImg.getAttribute('fetchpriority')) lcpImg.setAttribute('fetchpriority','high');
  }
  function prioritizeFirstImage(){
    var lcpImg=d.querySelector('main img:not([loading="lazy"])');
    if(lcpImg && !lcpImg.getAttribute('fetchpriority')) lcpImg.setAttribute('fetchpriority','high');
  }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded', function(){ prioritizeFirstImage(); a11yHardening(); runIdle(optimizeMedia, 1800); runIdle(a11yHardening, 2600); });
  else { prioritizeFirstImage(); a11yHardening(); runIdle(optimizeMedia, 1800); runIdle(a11yHardening, 2600); }
})();
